import { render, staticRenderFns } from "./CurrentPlan.vue?vue&type=template&id=21e3cd20&scoped=true&"
import script from "./CurrentPlan.vue?vue&type=script&lang=js&"
export * from "./CurrentPlan.vue?vue&type=script&lang=js&"
import style0 from "./CurrentPlan.vue?vue&type=style&index=0&id=21e3cd20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e3cd20",
  null
  
)

export default component.exports